module.exports = __webpack_public_path__ + "img/chat_icon_small.0bce0934.svg";